document.addEventListener('DOMContentLoaded', function() {
    initializeProductMenu();
});

function initializeProductMenu() {
    // Get all category elements
    const categories = document.querySelectorAll('.product-menu__category');
    const breadcrumbCategory = document.querySelector('.current-category');
    const viewAllLink = document.querySelector('[data-category-url]');
    
    // Add mouseenter and click event listeners to each category
    categories.forEach(category => {
        // Mouse enter event for preview
        category.addEventListener('mouseenter', function() {
            handleCategoryHover(this, categories, breadcrumbCategory, viewAllLink);
        });

        // Click event for navigation
        const categoryLink = category.querySelector('.product-menu__category-link');
        if (categoryLink) {
            categoryLink.addEventListener('click', function(e) {
                // Don't prevent default - let the link work normally
                // Just update the active state
                // categories.forEach(cat => cat.classList.remove('active'));
                // category.classList.add('active');
                // 如果是 All 分类，阻止默认行为
                // if (category.getAttribute('data-category') === 'all') {
                //     e.preventDefault();
                    categories.forEach(cat => cat.classList.remove('active'));
                    category.classList.add('active');
                    updateProductDisplay('all');
                // }
            });
        }
    });
    
    // Store original URL for "All" category
    if (viewAllLink) {
        viewAllLink.setAttribute('data-original-url', viewAllLink.href);
    }
    
    // Set "All" category as active by default
    const allCategory = document.querySelector('.product-menu__category[data-category="all"]');
    if (allCategory) {
        allCategory.classList.add('active');
    }
    // 初始化显示 All 分类的数据
    updateProductDisplay('all');
}

function handleCategoryHover(hoveredCategory, allCategories, breadcrumbCategory, viewAllLink) {
    // Remove active class from all categories
    allCategories.forEach(cat => cat.classList.remove('active'));
    
    // Add active class to hovered category
    hoveredCategory.classList.add('active');
    
    // Update breadcrumb
    if (breadcrumbCategory) {
        breadcrumbCategory.textContent = hoveredCategory.textContent.trim();
    }
    
    // Get category URL and name from data attributes
    const categoryUrl = hoveredCategory.getAttribute('data-url');
    const categoryName = hoveredCategory.getAttribute('data-category');
    
    // Update View All link URL
    updateViewAllLink(viewAllLink, categoryName, categoryUrl);
    
    // Update product display
    updateProductDisplay(categoryName);
}

function updateViewAllLink(viewAllLink, categoryName, categoryUrl) {
    if (!viewAllLink) return;
    
    if (categoryName === 'all') {
        // Reset to original URL for "All" category
        viewAllLink.href = viewAllLink.getAttribute('data-original-url');
    } else if (categoryUrl) {
        // Update URL for specific category
        viewAllLink.href = categoryUrl;
    }
}

function updateProductDisplay(categoryName) {
    // Get all product items
    const products = document.querySelectorAll('.product-menu__item');
    
    // Hide all products first
    products.forEach(product => {
        product.style.display = 'none';
    });
    
    if (categoryName === 'all') {
        const allProducts = document.querySelectorAll('.product-menu__item[data-category="all"]');
        allProducts.forEach((product, index) => {
            if (index < 8) {
                product.style.display = 'block';
            }
        });
    } else {
        // Show products of selected category (up to 8)
        const categoryProducts = document.querySelectorAll(`.product-menu__item[data-category="${categoryName}"]`);
        // categoryProducts.forEach((product, index) => {
        //     if (index < 8) {
        //         product.style.display = 'block';
        //     }
        // });
        categoryProducts.forEach((product, index) => {
            // product.style.display = 'block';
            if (index < 8) {
                product.style.display = 'block';
            }
            
        });
    }
} 